
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MenuData from '@/data/Menu';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import LanguageButton from '@/components/LanguageButton.vue';
import DocumentButton from '@/components/DocDownload.vue';
import utils from '@/services/utils';
import { SOCKET_URL } from '@/utils/api';
import { io } from 'socket.io-client';

@Component({
  components: {
    LanguageButton,
    DocumentButton,
  },
})
export default class Sidebar extends Vue {
  @Prop() readonly toggleSidebar!: Function;

  AuthInstance = getModule(AuthModule, this.$store);

  utilsInstance = utils;

  menuList = MenuData.menuList;

  userOnline = 0;

  currentChild = null;

  ioConnect: any;

  isLoad = false;

  token = utils.getUserPersistent().token;

  async created() {
    if (this.AuthInstance.user.role === 'COMPANY') {
      this.isLoad = true;
      this.ioConnect = await io(SOCKET_URL, {
        auth: { token: `Bearer ${this.token}` },
        transports: ['websocket'],
      });
      this.ioConnect.on('connect_error', (error) => {
        if (error.data.type === 'UnauthorizedError') {
          console.log('User token has expired');
        }
      });
      this.ioConnect.on('updateOnlineUsers', async (res) => {
        if (res && res.data) {
          this.handleUserOnline(res.data);
        }
      });
    }
    this.menuList = this.menuList
      .filter((item: any) => this.AuthInstance.user.userPermission[item.key] !== 'off'
        && item.allow
        && item.allow.includes(this.AuthInstance.user.role));
    await this.menuList.forEach((item: any, index) => {
      if (item.child) {
        this.menuList[index].child = item.child
          .filter((i: any) => (
            (i.allow && i.allow.includes(this.AuthInstance.user.role))
            && (!i.isEditPermKey || this.AuthInstance.user.userPermission[i.isEditPermKey] === 'edit')
            && (!i.level || i.level >= this.AuthInstance.user.level)
          ));
      }
    });
  }

  handleUserOnline(data: any) {
    this.userOnline = 0;
    const user = Object.values(data);
    // eslint-disable-next-line no-return-assign
    user.forEach((v: any) => this.userOnline += v.amount);
    this.isLoad = false;
  }

  closeSidebar() {
    this.toggleSidebar();
  }

  toggleChild(idx) {
    this.currentChild = idx !== this.currentChild ? idx : null;
  }

  async onLogout() {
    await this.AuthInstance.Logout();
    await this.$router.push('/login');
  }
}
